import { mapActions, mapGetters } from 'vuex'
import { SelectedSiteMixin } from '../Site/SelectedSiteMixin'
import { ErrorHelper } from '@/helpers/ErrorHelper'

export const FormatSettingDateCacheMixin = {
  mixins: [SelectedSiteMixin],
  data () {
    return {
      error: ''
    }
  },
  computed: {
    ...mapGetters('FormatSettingDate', [
      'findDateFormatSettingCache'
    ]),
    dateFormatSettingCache () {
      return this.findDateFormatSettingCache(this.selectedSiteId)
    },
    dateFormatSetting () {
      return this.dateFormatSettingCache ? this.dateFormatSettingCache.value : null
    },
    loadingDateFormatSetting () {
      return !!this.dateFormatSettingCache && this.dateFormatSettingCache.loading
    }
  },
  watch: {
    selectedSiteId () {
      this.refreshDateFormatSetting()
    }
  },
  methods: {
    ...mapActions('FormatSettingDate', [
      'fetchDateFormatSetting'
    ]),
    refreshDateFormatSetting () {
      if (!this.dateFormatSettingCache || this.dateFormatSettingCache.retry) {
        this.tryFetchDateFormatSetting()
      }
    },
    tryFetchDateFormatSetting () {
      const self = this
      if (!self.selectedSiteId) {
        return
      }
      self.error = ''
      self.fetchDateFormatSetting(self.selectedSiteId)
        .catch(error => { self.error = ErrorHelper.getError(error) })
    }
  },
  created () {
    this.refreshDateFormatSetting()
  }
}
